// korns/src/pages/Products/Pricelist.js
import React, { useEffect, useState, useRef } from "react";
import IconMenu from "../../components/subMenu/SubMenu";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import useSave from "../../Hooks/useSave";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import MUIDataTable from "mui-datatables";
import { Autocomplete } from "@mui/material";
import InputMask from "react-input-mask";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import AddIcon from "@mui/icons-material/Add";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Paper, TextField } from "@mui/material";
import { Box } from "@mui/system";

export default function Pricelist() {
  const [pricelist, setPricelist] = useState({
    pricelistName: "",
    percentChange: null,
  });
  const [products, setProducts] = useState([]);
  const [pricelistExceptions, setPricelistExceptions] = useState([]);
  const [open, setOpen] = useState(false);

  const name = useRef();

  const navigate = useNavigate();
  const { fetchGraphql, DialogSave } = useSave();

  const { id } = useParams();

  console.log(id);

  const addonOptions = {
    record: {
      pricelistExceptionId: `${pricelistExceptions.length + 1}-new`,
      productId: null,
      productName: "",
      productPrice: null,
    },
    save: (tableMeta) => {
      // console.log(tableMeta, pricelistExceptions, tableMeta.rowData[0]);

      const copyState = [...pricelistExceptions];

      const pricelistException = copyState.find(
        (item) => item.pricelistExceptionId === tableMeta.rowData[0],
      );

      // console.log(pricelistException);

      if (pricelistException.pricelistExceptionId.includes("new")) {
        // console.log("new");

        fetchGraphql({
          query: `mutation CreatePricelist($pricelistId: ID, $pricelistException: pricelistExceptionInput) {
          createPricelistException(pricelistId: $pricelistId, pricelistException: $pricelistException)
        }`,
          variables: {
            pricelistId: id,
            pricelistException: {
              productId: pricelistException.productId,
              productPrice: pricelistException.productPrice,
            },
          },
        }).then((result) => {
          console.log(result.data.createPricelistException);

          pricelistException.pricelistExceptionId =
            result.data.createPricelistException;

          setPricelistExceptions(copyState);
        });
      } else {
        // console.log("old");

        fetchGraphql({
          query: `mutation UpdatePricelist($pricelistExceptionId: ID, $pricelistException: pricelistExceptionInput) {
          updatePricelistException(pricelistExceptionId: $pricelistExceptionId, pricelistException: $pricelistException)
        }`,
          variables: {
            pricelistExceptionId: pricelistException.pricelistExceptionId,
            pricelistException: {
              productId: pricelistException.productId,
              productPrice: pricelistException.productPrice,
            },
          },
        }).then((result) => {});
      }
    },
    edit: () => {},
    delete: (tableMeta) => {
      const pricelistException = pricelistExceptions.find(
        (item) => item.pricelistExceptionId == tableMeta.rowData[0],
      );

      fetchGraphql({
        query: `mutation UpdatePricelist($pricelistExceptionId: ID) {
          deletePricelistException(pricelistExceptionId: $pricelistExceptionId)
        }`,
        variables: {
          pricelistExceptionId: pricelistException.pricelistExceptionId,
        },
      }).then((result) => {});
    },
  };

  useEffect(() => {
    console.log(id, pricelist);
    if (id === "new-pricelist") {
      name.current.focus();
      return;
    } else {
      fetchGraphql({
        query: `query Pricelist($pricelistId: ID) {
          pricelist(pricelistId: $pricelistId) {
            pricelistId
            pricelistName
            percentChange
          }
          pricelistExceptions(pricelistId: $pricelistId) {
            pricelistExceptionId
            pricelistId
            productId
            productPrice
            productName
          }
          products {
            productId
            productName
          }
        }`,
        variables: { pricelistId: id },
      }).then((result) => {
        setPricelist(result.data.pricelist);
        setPricelistExceptions(result.data.pricelistExceptions);
        setProducts(
          result.data.products.map((item) => ({
            ...item,
            title: item.productName,
          })),
        );
      });
    }
  }, []);

  const [textField, selectField, newRecord, actions, options] =
    useDatatableAddon(
      pricelistExceptions,
      setPricelistExceptions,
      "pricelistExceptionId",
      addonOptions,
    );

  const columns = [
    {
      name: "pricelistExceptionId",
      options: {
        display: "excluded",
      },
    },
    {
      name: "productName",
      label: "Product Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            firstRow: true,
            width: "200px",
            values: products,
            id: "productId",
          };

          return selectField(tableMeta, value, options);
        },
      },
    },
    {
      name: "productPrice",
      label: "Product Price",
      options: {
        // display: false,

        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            tabNext: true,
            width: "250px",
            type: "number",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    { ...actions },
  ];

  const menuHeaderPricelist = {
    icon: "",
    name: `Pricelist ${pricelist.pricelistName}`,
  };

  const menuPricelist = [
    {
      link: `/products/pricelists/pricelist/${id}`,
      path: "/pricelist/:id",
      name: "Pricelist",
    },
    {
      link: `/products/pricelists/pricelist/report/${id}`,
      path: "/pricelist/report/:id",
      name: "Report",
    },
  ];

  return (
    <>
      <IconMenu menuHeader={menuHeaderPricelist} menu={menuPricelist} />
      <DialogSave />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box
        sx={{ display: "flex", flexDirection: "column", width: "100%", ml: 2 }}
      >
        <Button
          sx={{ margin: "0px auto 20px 0px", marginRight: "auto" }}
          variant="outlined"
          onClick={() => navigate("/products/pricelists")}
          id="back"
        >
          <ArrowBackIcon />
          Back
        </Button>

        <Paper
          sx={{
            margin: "2px",
            height: "100%",
            width: "100%",
            overflow: "auto",
          }}
        >
          <Box sx={{ width: "100%", display: "flex", alignItems: "center" }}>
            <TextField
              sx={{ margin: "20px" }}
              value={pricelist.pricelistName || ""}
              onChange={(e) => {
                setPricelist({
                  ...pricelist,
                  pricelistName: e.target.value,
                });
              }}
              onBlur={(e) => {
                if (id === "new-pricelist" && e.relatedTarget?.id !== "back") {
                  if (pricelist.pricelistName === "") {
                    alert("Please enter a name to create a pricelist");

                    setTimeout(() => name.current.focus(), 500);
                  } else {
                    fetchGraphql({
                      query: `mutation UpdatePricelist($pricelist: pricelistInput) {
                            createPricelist(pricelist: $pricelist)
                          }`,
                      variables: {
                        pricelist,
                      },
                    }).then((result) => {
                      navigate(
                        `/products/pricelists/pricelist/${result.data.createPricelist}`,
                      );
                    });
                  }
                } else if (
                  id === "new-pricelist" &&
                  e.relatedTarget?.id === "back"
                ) {
                  return;
                } else {
                  fetchGraphql({
                    query: `mutation UpdatePricelist($pricelist: pricelistInput) {
                          updatePricelist(pricelist: $pricelist)
                        }`,
                    variables: {
                      pricelist,
                    },
                  });
                }
              }}
              inputRef={name}
              label="Pricelist Name"
              variant="outlined"
            />

            <TextField
              sx={{ margin: "20px 0px" }}
              value={pricelist.percentChange || ""}
              onChange={(e) => {
                setPricelist({
                  ...pricelist,
                  percentChange: parseFloat(e.target.value),
                });
              }}
              onBlur={() => {
                fetchGraphql({
                  query: `mutation UpdatePricelist($pricelist: pricelistInput) {
                            updatePricelist(pricelist: $pricelist)
                          }`,
                  variables: {
                    pricelist,
                  },
                });
              }}
              label="Percent Change"
              variant="outlined"
              type="number"
            />

            <Button
              sx={{ margin: "20px 20px 20px auto" }}
              variant="contained"
              onClick={() =>
                newRecord({
                  pricelistExceptionId: `${pricelistExceptions.length + 1}-new`,
                  productId: null,
                  productName: "",
                  productPrice: null,
                })
              }
            >
              <AddIcon />
              New Exception
            </Button>
          </Box>
          <Box sx={{ margin: "0px 20px" }}>
            <MUIDataTable
              sx={{ height: "100px" }}
              title={"Pricelist Exceptions"}
              data={pricelistExceptions}
              columns={columns}
              options={options}
            />
          </Box>
        </Paper>
      </Box>
    </>
  );
}
